import { useQuery } from '@tanstack/react-query';
import * as ServiceApi from '../services';

const getFuelStores = async () => {
  const {
    data: {
      results
    }
  } = await ServiceApi.fetchFuelStores();
  return results;
};

const useQueryFuelStores = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getFuelStores'],
    queryFn: () => getFuelStores(),
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useQueryFuelStores;

    